module.exports = __webpack_public_path__ + "img/157.12c76463.png";